<template>
  <div class="map-container">
    <LMap
      ref="map"
      :zoom.sync="zoom"
      :options="mapOptions"
      :center="center"
      :bounds="bounds"
      :min-zoom="minZoom"
      :max-zoom="maxZoom"
    >
      <l-control-zoom position="topright" />

      <LTileLayer :url="url"></LTileLayer>
      <LLayerGroup layer-type="overlay" name="Devices">
        <LMarker
          :key="device._id"
          v-for="device in devices"
          :lat-lng="[device.stats.latitude, device.stats.longitude]"
          @click="viewdevice(device)"
        >
          <l-popup v-if="device.type.toLowerCase() !== 'loctrack'">
            <div class="p-2">
              <div class="font-bold mb-2">{{ device.settings.name }}</div>
              <div>{{ $t("temperature") }}: {{ device.stats.temperature }}</div>
              <div v-if="device.type == 'mote' || device.type == 'gps-vt'">
                {{ $t("humidity") }}: {{ device.stats.humidity }}
              </div>
            </div>
          </l-popup>
          <l-icon :icon-anchor="[18, 0]">
            <img
              v-if="device.status == 'critical'"
              src="../../assets/images/marker-critical.svg"
              alt=""
              height="40px"
            />
            <img
              v-else
              src="../../assets/images/marker-good.svg"
              alt=""
              height="40px"
            />
          </l-icon>
        </LMarker>
      </LLayerGroup>
    </LMap>
  </div>
</template>

<script>
import "vue-loading-overlay/dist/vue-loading.css";
import "leaflet/dist/leaflet.css";

import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LIcon,
  LControlZoom,
  LLayerGroup,
  // LControlLayers,
} from "vue2-leaflet";
import { latLngBounds } from "leaflet";

export default {
  name: "AllDevicesMap",
  props: {
    devices: Array,
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LIcon,
    LControlZoom,
    LLayerGroup,
    // LControlLayers,
  },
  data() {
    return {
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      // url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
      zoom: 12,
      center: [6.21024000000001, 3.4570065],
      bounds: null,
      mapOptions: {
        zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      minZoom: 4,
      maxZoom: 16,
    };
  },
  mounted() {
    this.setBounds();
  },
  watch: {
    devices: {
      handler: function () {
        this.setBounds();
      },
      deep: true,
    },
  },
  methods: {
    viewdevice(device) {
      setTimeout(() => {
        this.center = [device.stats.latitude, device.stats.longitude];
      }, 600);
    },
    setBounds() {
      let bounds = [];
      // console.log("devices updated");
      for (let i = 0; i < this.devices.length; i++) {
        bounds.push([
          this.devices[i].stats.latitude,
          this.devices[i].stats.longitude,
        ]);
      }
      if (this.devices.length <= 0) {
        this.bounds = latLngBounds([
          [6.50081290280357, 3.46963806152345],
          [7.02991732677597, 3.38716201782228],
        ]);
      } else {
        this.bounds = latLngBounds(bounds);
      }
    },
  },
};
</script>

<style scoped>
.map-container {
  height: 100%;
  width: 100%;
  /* transition: 0.5s ease-in; */
}
.control-layer {
  background: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.tools-container {
  position: relative;
  background: #fff;
  /* padding: 10px; */
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.tools {
  position: absolute;
  display: flex;
  flex-direction: column;
  top: 100%;
  right: 0;
  margin-top: 10px;
  height: 0;
  overflow: hidden;
  transition: 0.3s ease-out;
  padding: 0 10px;
  background: black;
}
.tools-show {
  height: 80px;
}
.mask {
  position: fixed;
  top: 0;
  left: 0;
  background: transparent;
  height: 100vh;
  width: 100vw;
  cursor: default;
}
</style>

<i18n>
{}
</i18n>
